import { type ReactNode } from 'react';
import { ColorPicker } from '@/components/ui/color-picker';
import { ProfileSection, ProfileField } from './profile-section';
import type { ProfileUpdate } from '../types';

type Props = {
  values: ProfileUpdate;
  setField: <K extends keyof ProfileUpdate>(k: K, v: ProfileUpdate[K]) => void;
};

export function ColorSection({ values, setField }: Props): ReactNode {
  return (
    <ProfileSection
      title="Tu color"
      description="Aparece en gráficas y elementos donde te representamos."
    >
      <ProfileField label="Color de acento">
        <ColorPicker
          value={values.member_color ?? ''}
          onChange={(v) => setField('member_color', v)}
        />
      </ProfileField>
    </ProfileSection>
  );
}
